__webpack_require__.p = "https://dev.giaophanphucuong.com/_next/";